<template>
  <div>
    <v-card flat class="mb-5" v-show="filter">
      <v-form>
        <v-row>
          <v-col cols="6" class="pb-0" xs="12">
            <v-text-field
              clearable
              dense
              outlined
              label="Name"
              v-model="form.name"
            ></v-text-field>
          </v-col>
          <v-col cols="6" class="pb-0" xs="12">
            <v-autocomplete
              clearable
              dense
              outlined
              :items="statuses"
              label="Status"
              item-text="title"
              item-value="title"
              v-model="form.status"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              class="mr-5"
              color="blue-grey darken-1"
              dark
              depressed
              @click="search"
              >Search</v-btn
            >
            <v-btn dark color="grey" depressed outlined @click="resetFilter"
              >Reset Filter</v-btn
            >
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <v-data-table
      :headers="headers"
      :items="informatives"
      :options.sync="options"
      :server-items-length="totalInformatives"
      :footer-props="footerProps"
      :loading="loading"
    >
      <template v-slot:item.title="{ item }">
        <v-btn text color="teal darken-2" @click="edit(item, false)">
          {{ item.title }}
        </v-btn>
      </template>
      <template v-slot:item.is_active="{ item }">
        <record-activator
          :item="item"
          table="informatives"
          @reload="paginate"
        ></record-activator>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="amber darken-2"
              v-bind="attrs"
              v-on="on"
              @click="edit(item)"
            >
              <v-icon>mdi-square-edit-outline</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              v-bind="attrs"
              v-on="on"
              @click="remove(item)"
            >
              <v-icon>mdi-close-box-outline</v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
    </v-data-table>
    <create-informative
      ref="createInformativeDialog"
      @reload="paginate"
    ></create-informative>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import createInformative from "../../../components/create-informative.vue";
import RecordActivator from "../../../components/record-activator.vue";
export default {
  components: { createInformative, RecordActivator },
  data() {
    return {
      headers: [
        { text: "", value: "is_active", width: "50" },
        { text: "Title", value: "title" },
        { text: "Effective Date", value: "effective_at" },
        { text: "Expires On", value: "expires_at" },
        { text: "Sort Order", value: "sort_order" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      loading: true,
      footerProps: {
        itemsPerPageOptions: [25, 50, 100],
      },
      totalInformatives: 0,
      options: {
        groupBy: [],
        groupDesc: [],
        itemsPerPage: 100,
        multiSort: false,
        mustSort: false,
        page: 1,
        sortBy: [],
        sortDesc: [],
      },
      filter: false,
      form: {},
      statuses: ["Active", "Inactive"],
    };
  },
  watch: {
    options: {
      handler() {
        this.paginate(this.form);
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      informatives: (state) => state.informatives.informatives,
    }),
  },
  methods: {
    ...mapActions(["getInformatives"]),
    resetFilter() {
      this.form = this.initForm();
      this.paginate();
    },
    search() {
      this.paginate(this.form);
    },
    initForm() {
      return {
        name: "",
        status: "",
      };
    },
    paginate(params = {}) {
      this.loading = true;
      this.getInformatives({ ...this.options, ...params }).then((r) => {
        this.totalInformatives = +r.data.total;
        this.options.itemsPerPage = +r.data.per_page;
        this.loading = false;
      });
    },
    edit(item, editable = true) {
      this.$refs.createInformativeDialog.viewing = !editable;
      this.$refs.createInformativeDialog.edit(item);
    },
    remove(item) {
      this.$confirm("Do you really want to delete this informative?", {
        color: "error",
        title: "Warning",
      }).then((res) => {
        if (res) {
          window.axios.delete(`/api/informatives/${item.id}`).then(() => {
            this.paginate();
            this.$toast.success("Informative deleted.");
          });
        }
      });
    },
  },
};
</script>